import { Tab } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import React from "react";
import { RecordDetailsTabNames } from "@publicPortal/utils/enums";

interface EnforcementNoticeTabsProps {
    cardName: ENoticeTabs;
    handleChangeTab: (newTab: ENoticeTabs) => void;
}

const EnforcementNoticeTabs: React.FC<EnforcementNoticeTabsProps> = (props) => {
    const { cardName, handleChangeTab } = props;
    const tabList: ENoticeTabs[] = [RecordDetailsTabNames.Summary, RecordDetailsTabNames.Documents, RecordDetailsTabNames.Map];

    return (
        <Tabs aria-label="Notice Navigation Tabs" sx={{ margin: "2rem 0 3rem 0" }} value={cardName} onChange={(event, newTab: ENoticeTabs) => handleChangeTab(newTab)}>
            {tabList.map((tabName) => {
                return <Tab key={tabName} disableRipple label={tabName} value={tabName}></Tab>;
            })}
        </Tabs>
    );
};

type ENoticeTabs = RecordDetailsTabNames.Summary | RecordDetailsTabNames.Documents | RecordDetailsTabNames.Map;

export default EnforcementNoticeTabs;
export type { ENoticeTabs };
